import { StyleSheet } from 'react-native'
import { memo } from 'react'
import { DrawerColorDots } from '../DrawerColorDots/DrawerColorDots'
import { useStore } from '../../../models'
import { DS } from '../../../design-system'

export const DrawerCardColors = memo(({ useFourColor }: { useFourColor: boolean }) => {
  const initialSelectedIndex = useFourColor ? 0 : 1
  const store = useStore()

  return (
    <DS.Frame style={styles.container}>
      <DS.Text variant="Body Small/Regular">Card Colors</DS.Text>
      <DrawerColorDots
        initialSelectedIndex={initialSelectedIndex}
        onChangeColorIndex={(index) => {
          if (index === 0) {
            // four color enabled
            store.game.setIsFourColoredDeckEnabled(true)
          } else if (index === 1) {
            // four color disabled
            store.game.setIsFourColoredDeckEnabled(false)
          }
        }}
      />
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: DS.spacing[4]
  }
})
